import React, {Component} from 'react';
//import { Spinner } from 'react-bootstrap';
import ajax, {Request} from 'superagent';
import {Elements, StripeProvider, injectStripe} from 'react-stripe-elements';
import {haulcheckURl, assuredURL, assuredAPIURL, earthidealURL, url} from '../../../../constants';
import jwtDecode from 'jwt-decode';
import ShowCardForm from './ShowCardForm';
import CardEntryForm from './CardEntryForm';
import "./style.css";

class stripeForm extends Component {

	constructor(props){
        super(props);

        const userJWT = localStorage.getItem('token');
        const user = jwtDecode(userJWT);

        this.state = {
            //userId: user.id,
            username: user['cognito:username'],
            userEmail: user.email,
           	stripeToken: "",
           	customerId: "",
           	showLoadingWidget: false,
        }

    }

    componentWillMount = () => {
        this.setState({showLoadingWidget: true});
    	ajax.get(`${assuredAPIURL}/stripe/paymentInfoByUsername/${this.state.username}`)
        .then(res => {
            let {paymentMethod, stripeToken, customerId} = res.body.data;
            this.setState({paymentMethod, stripeToken, customerId, showLoadingWidget: false});
            if (this.props.getStripePaymentMethod) this.props.getStripePaymentMethod(paymentMethod);
        });
    }

    getStripePaymentMethod = (idpayment) => {
    	this.setState({showLoadingWidget: true});
    	ajax.get(`${assuredAPIURL}/stripe/payment/${idpayment}`)
		.then(res => {
			console.log("getStripePaymentMethod res:", res);
			let paymentMethod = res.body.payment;
			this.setState({paymentMethod, showLoadingWidget: false});
			if (this.props.getStripePaymentMethod) this.props.getStripePaymentMethod(paymentMethod);
		});
    }

    resetCard = () => {
    	this.setState({
    		paymentMethod: null
    	})
    }

    displayLoadingWidget = () => {
    	this.setState({showLoadingWidget: true});
    }

    hideLoadingWidget = () => {
    	this.setState({showLoadingWidget: false});
    }

    render() {
    	if (this.state.showLoadingWidget){
            return(<div className="loader">Loading...</div>)
    	} else if (!this.state.paymentMethod){
			return( <CardEntryForm getStripePaymentMethod={this.getStripePaymentMethod} 
				displayLoadingWidget={this.displayLoadingWidget}
				hideLoadingWidget={this.hideLoadingWidget} /> )
		} else {
			return(<ShowCardForm resetCard={this.resetCard} stripePayment={this.state.paymentMethod} />)
		}
    }
    

}

export default injectStripe(stripeForm);
